<div class="d-flex flex-row p-3 bg-white header-box settings-header justify-content-between">
  <h2 class="heading regular-font-weight d-flex align-items-center ps-3">
    <mat-icon *ngIf="SoapConfigureViewMobile" class="d-md-none">arrow_back_ios</mat-icon>
    Settings / User Preferences
  </h2>
  <img *ngIf="isLIC" [src]="cvaUI_url+ '/assets/images/logo.svg'" alt="CVA logo" width="70px" />
  @if(!isLIC){
  <div class="d-md-none d-flex align-items-center user-profile">
    <mat-icon [matMenuTriggerFor]="userMenu" class="pointer">person_outline</mat-icon>
    <mat-menu #userMenu="matMenu" xPosition="after" class="user-menu-collapse">
      <cva-side-nav-user-menu-items></cva-side-nav-user-menu-items>
    </mat-menu>
  </div>
  }
</div>
<div
  class="soap-config-wrapper settings-theme overflow-y-auto p-3 position-relative d-flex flex-column container-fluid">
  <!--SOAP templates-->
  <mat-tab-group *ngIf="!isLoading" animationDuration="0ms" class="settings-tabs" mat-stretch-tabs="false"
    mat-align-tabs="start">
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="title-panel">Templates</span>
      </ng-template>
      <div class="settings-tab-content">
        <ng-container *ngTemplateOutlet="soaptemplate"></ng-container>
      </div>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="title-panel">Preferences</span>
      </ng-template>
      <div class="settings-tab-content">
        <ng-container *ngTemplateOutlet="preferenceTemplate"></ng-container>
      </div>
    </mat-tab>
  </mat-tab-group>

  <ng-template #soaptemplate>
    <div class="templates-section">
      <div class="flex-container template-toolbar justify-content-between">
        <div class="d-flex flex-grow-1 me-2 align-items-center">
          <label class="regular-font-size-weight small-screen me-2" for="patientId">
            Search
          </label>
          <div class="search-container">
            <mat-icon class="text-icon search-icon">search</mat-icon>
            <input type="text" class="form-control search-input w-100 h-100" (input)="applyFilter($event)"
              [(ngModel)]="filterName" placeholder="Search by name or category">
            <button type="button" class="no-button" (click)="clearFilter()">
              <mat-icon *ngIf="filterName" class="text-icon cancel-icon">cancel</mat-icon>
            </button>
          </div>
        </div>
        <div class="d-flex justify-content-between toolbar-action">
          <button type="button" class="btn btn-outline-secondary add-aptmt-btn-lg" (click)="onTemplateButtonClick()">
            <i class="bi bi-plus-lg new-aptmt-icon"></i>
            <span class="small-screen">Add Template</span>
          </button>
        </div>
      </div>

      <div>
        <!-- Mobile screen -->
        <div class="d-block d-sm-none">
          <div *ngIf="dataSource.filteredData && dataSource.filteredData.length;else noRecordFound">
            <div class="my-3" *ngFor="let template of dataSource.filteredData;let last = last">
              <cva-template-card [template]="template" (actionClick)="onActionClick($event)"
                [defaultTemplate]="template['identifier'] === defaultTemplate"
                (rowClick)="template['createdBy'] === CREATED_BY.ME ? editRow($event) : false">
              </cva-template-card>
            </div>
          </div>
          <ng-template #noRecordFound>
            <div class="apt-container justify-content-center my-4 text-grey">
              <mat-card>
                <mat-card-content class="text-center">
                  <strong>No Record Found.</strong>
                </mat-card-content>
              </mat-card>
            </div>
          </ng-template>
        </div>
        <!-- Desktop Screen -->
        <div class="d-none d-sm-block">
          <div class="template-table">
            <table *ngIf="soapTemplateOptions && soapTemplateOptions.length" mat-table [dataSource]="dataSource"
              matSort>
              <ng-container *ngFor="let col of tableHeaders; let i = index" [matColumnDef]="col.field">
                <th mat-header-cell *matHeaderCellDef>
                  <div *ngIf="col.sortable; else notSortable" mat-sort-header>
                    {{ col.label }}
                  </div>
                  <ng-template #notSortable>{{ col.label }}</ng-template>
                </th>
                <td mat-cell *matCellDef="let row" [ngClass]="col.tdClass || ''" [style.width]="col.width || ''">

                  <ng-container *ngIf="col.field === 'default'">
                    @if(row.identifier === defaultTemplate){
                    <mat-icon>check</mat-icon>
                    }@else{
                    <mat-icon></mat-icon>
                    }
                  </ng-container>
                  <ng-container *ngIf="col.field === 'name'">
                    <div class="d-flex align-items-center">
                      <button type="button" class="no-button" (click)="onToggleFavorite(row)">
                        <mat-icon [ngClass]="{'text-yellow-500':row.starred}">
                          {{ row.starred ? 'star' : 'star_border' }}
                        </mat-icon>
                      </button>
                      <button type="button" [matTooltip]="row['description'] ||''"
                        [ngClass]="row.createdBy !== CREATED_BY.SYSTEM ? 'primary-color' : ''"
                        (click)="row.createdBy !== CREATED_BY.SYSTEM ? templateViewer(row):null"
                        class="narrow-column ms-2">{{ row[col.field] }}</button>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="col.isAction">
                    <mat-icon class="cursor-pointer" [matMenuTriggerFor]="menu">more_vert</mat-icon>

                    <mat-menu #menu="matMenu">
                      <button type="button" mat-menu-item (click)="editRow(row)"
                        [class.cursor-not-allowed]="row.createdBy !== CREATED_BY.ME"
                        [disabled]="row.createdBy !== CREATED_BY.ME">
                        <mat-icon>edit</mat-icon> Edit
                      </button>
                      <button type="button" mat-menu-item (click)="deleteRow(row)"
                        [class.cursor-not-allowed]="row.createdBy !== CREATED_BY.ME"
                        [disabled]="row.createdBy !== CREATED_BY.ME">
                        <mat-icon>delete</mat-icon> Delete
                      </button>
                      <button type="button" mat-menu-item (click)="onTemplateTypeChange(row)">
                        <mat-icon>check</mat-icon> Set Default
                      </button>
                      <button type="button" mat-menu-item (click)="onToggleFavorite(row)">
                        <mat-icon>star_border</mat-icon>
                        {{row.starred ? 'Remove from favorite' : 'Add to favorite'}}
                      </button>
                    </mat-menu>

                  </ng-container>
                  <ng-container *ngIf="col.isDate">
                    {{ row[col.field] | date: 'MMMM dd, yyyy' }}
                  </ng-container>

                  <!-- For other fields, display the raw value -->
                  <ng-container *ngIf="!col.isDate && !col.isAction && col.field !== 'name'">
                    {{ row[col.field] }}
                  </ng-container>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
          <mat-paginator [pageSize]="pageSize" #paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons
            aria-label="Select page of periodic elements">
          </mat-paginator>
          @if(dataSource.filteredData.length === 0) {
          <div class="text-center text-lg text-gray-500 mt-4">
            No templates found.
          </div>
          }
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #preferenceTemplate>
    <div class="ml-mr-150 preferences-section">
      <div class="flex-container preference-row justify-content-between mb-4">
        <div class="d-flex flex-column flex-grow-1 me-2 preference-content">
          <div class="d-flex align-items-center mb-2">
            <label class="me-2 preference-label" for="patientId">
              Show consent pop-up
            </label>
            <mat-icon
              matTooltip="When this is turned on, you'll get a pop-up at the start of each session asking you to get the patient’s consent to record."
              matTooltipPosition="right" class="cursor-pointer mat-info-icon">
              info
            </mat-icon>
          </div>
          <p class="gray-font preference-desc">Enable showing patient consent pop-up on start of every session.</p>
        </div>
        <div class="d-flex justify-content-between preference-control">
          <mat-slide-toggle [(ngModel)]="patientConsent" class="toggle-button" color="primary" hideIcon="true"
            (change)="updatePreference('patientConsent')">
          </mat-slide-toggle>
        </div>
      </div>
      <div class="flex-container preference-row justify-content-between mb-4">
        <div class="d-flex flex-column flex-grow-1 me-2 preference-content">
          <div class="d-flex align-items-center mb-2">
            <label class="me-2 preference-label" for="patientId">
              Font size
            </label>
            <mat-icon
              matTooltip="Consultation notes font size can be adjusted to improve readability by choosing from Small, Medium, or Large options."
              matTooltipPosition="right" class="cursor-pointer mat-info-icon">
              info
            </mat-icon>
          </div>
          <p class="gray-font preference-desc">Font size for consultation notes</p>
        </div>
        <div class="preference-control">
          <select class="form-select preference-select" [(ngModel)]="consultationFont"
            (change)="updatePreference('consultationFont')">
            <option value="22">Small</option>
            <option value="24">Medium</option>
            <option value="28">Large</option>
          </select>
        </div>
      </div>
      <div class="flex-container preference-row justify-content-between mb-4">
        <div class="d-flex flex-column flex-grow-1 me-2 preference-content">
          <div class="d-flex align-items-center mb-2">
            <label class="me-2 preference-label" for="patientId">
              Show approve notes pop-up
            </label>
            <mat-icon
              matTooltip="When this is turned on, you'll get a confirmation pop-up while approving the consultation notes."
              matTooltipPosition="right" class="cursor-pointer mat-info-icon">
              info
            </mat-icon>
          </div>
          <p class="gray-font preference-desc">Enable showing pop-up on approving consultation notes.</p>
        </div>
        <div class="d-flex justify-content-between preference-control">
          <mat-slide-toggle [(ngModel)]="approvePopup" class="toggle-button" color="primary" hideIcon="true"
            (change)="updatePreference('approvePopup')">
          </mat-slide-toggle>
        </div>
      </div>
      <div class="flex-container preference-row justify-content-between mb-4">
        <div class="d-flex flex-column flex-grow-1 me-2 preference-content">
          <div class="d-flex align-items-center mb-2">
            <label class="me-2 preference-label" for="patientHistory">
              Patient History
            </label>
            <mat-icon matTooltip="Patient history will be used as contextual data while generating letter/Note"
              matTooltipPosition="right" class="cursor-pointer mat-info-icon">
              info
            </mat-icon>
          </div>
          <p class="gray-font preference-desc">Select the duration of patient history to include in letter/Note.</p>
        </div>
        <div class="preference-control">
          <select class="form-select preference-select" [(ngModel)]="patientHistory"
            (change)="updatePreference('patientHistory')">
            <option value="0">Do not include</option>
            <option value="3">Past 3 months</option>
            <option value="6">Past 6 months</option>
            <option value="9">Past 9 months</option>
            <option value="12">Past 12 months</option>
            <option value="15">Past 15 months</option>
            <option value="18">Past 18 months</option>
            <option value="21">Past 21 months</option>
            <option value="24">Past 24 months</option>
          </select>
        </div>
      </div>

      <div class="flex-container preference-row justify-content-between mb-4">
        <div class="d-flex flex-column flex-grow-1 me-2 preference-content">
          <div class="d-flex align-items-center mb-2">
            <label class="me-2 preference-label" for="accEligibilityRecipient">
              ACC Eligibility Recipient
            </label>
            <mat-icon
              matTooltip="When a default recipient is selected, it will be used automatically when posting. If no recipient is selected, you’ll be prompted to choose one when posting."
              matTooltipPosition="right" class="cursor-pointer mat-info-icon">
              info
            </mat-icon>
          </div>
          <p class="gray-font preference-desc">Select the recipient for ACC eligibility information.</p>
        </div>
        <div class="preference-control preference-select-wrapper">
          <select class="form-select preference-select" [(ngModel)]="accEligibilityRecipient"
            (change)="updatePreference('accEligibilityRecipient')" [disabled]="isLoadingAccRecipients">
            @if(isLoadingAccRecipients){
            <option value="">Loading recipients...</option>
            }@else {
            <option value="" class="text-center">---------</option>

            <option *ngFor="let recipient of accEligibilityAllRecipients" [value]="recipient.referenceId">
              {{ recipient.firstName }} {{ recipient.lastName }}
            </option>
            }

          </select>
          <span *ngIf="isLoadingAccRecipients" class="preference-loader">
            <span class="spinner"></span>
          </span>
        </div>
      </div>

      <div class="flex-container preference-row justify-content-between mb-4">
        <div class="d-flex flex-column flex-grow-1 me-2 preference-content">
          <div class="d-flex align-items-center mb-2">
            <label class="me-2 preference-label" for="patientId">
              Show live transcript
            </label>
            <mat-icon
              matTooltip="When this is turned on, the practitioner can view the live transcript during each clinical consultation as the conversation is being transcribed."
              matTooltipPosition="right" class="cursor-pointer mat-info-icon">
              info
            </mat-icon>
          </div>
          <p class="gray-font preference-desc">Enable showing the live transcript to the practitioner during clinical
            consultations.</p>
        </div>
        <div class="d-flex justify-content-between preference-control">
          <mat-slide-toggle [(ngModel)]="showLiveTranscription" class="toggle-button" color="primary" hideIcon="true"
            (change)="updatePreference('showLiveTranscription')">
          </mat-slide-toggle>
        </div>
      </div>
    </div>
  </ng-template>